import React from 'react';

import { HeadingItem } from '@/components/shared/headline/heading-item';
import { Container } from '@/components/shared/layout/container';
import { Grid } from '@/components/shared/layout/grid';
import { Section } from '@/components/shared/layout/section';
import { Image } from '@/components/shared/media/image';
import { ImageProps } from '@/components/shared/media/image/Image.props';
import { IButton } from '@/types/shared';

export interface IServiceHeader {
  theme?: null | 'white' | 'blue';
  logo?: ImageProps;
  title?: string;
  subTitle?: string;
  description?: string;
  highlight?: string;
  remark?: string;
  buttons?: IButton[];
  dataTestSection?: string;
  dataTest?: string;
  dataTrack?: string;
}

const View: React.FC<IServiceHeader> = ({
  theme = 'white',
  dataTestSection = 'section_service_header',
  ...props
}) => {
  return (
    <Section
      size="xl"
      backgroundColor={theme === 'white' ? 'white' : 'gradient-gray-light'}
      test={dataTestSection}
    >
      <Container>
        <Grid rowGap="6">
          {!!props.logo?.src && (
            <Image
              priority
              isMaxWidth
              src={props.logo?.src as string}
              alt={props.logo?.alt as string}
              width={props.logo?.width as number}
              height={props.logo?.height as number}
              layout="responsive"
              css={{
                justifySelf: 'center',
                '@maxsm': {
                  maxWidth: '$size-60 !important',
                },
              }}
            />
          )}
          <HeadingItem
            title={props.title as string}
            description={props.description}
            highlight={props.highlight}
            buttons={props.buttons}
            isCenter
          />
        </Grid>
      </Container>
    </Section>
  );
};

View.displayName = 'SectionServiceHeader';
export default View;
